
export type StuckTransWarnJson = {
	fileTotalcharsNum: number
	operateId: number
	origFileName: string
	remainCharsNum: number
}

export interface IHomePageConfig {
	toolsBoxFileMaxSize: string | number | null,
	checkSameFileSwitch: number | null,
	remainCharsCountByDay?: number // 当天剩余翻译字符数量
	remainTransCountByDay?: number // 当天剩余翻译次数
	trySeeDayCountLimit?: number | null
	trySeeOneCharsLimit?: number | null
	trySeeUserYetCount?: number | null
	visitorTransDoingJson?: object // 游客翻译中文件的json
	maybePdfPageChars: number | null, 	// pdf文件每页字符数
	bizOcrCostWord?: number | null // OCR 图片翻译每页额外扣除字符数
	highFidelityCostWord?: number | null // 高保真保护区每页额外扣除字符数
	stuckTransWarnJson: StuckTransWarnJson | null // 卡翻译的文件
	redPointNum?: number,
	aiChatTrialNumPerDay?: number // 每天最大对话次数
	aiChatTrialNumPerMon?: number  // 每月最大对话次数
	isCreatedTerm?: boolean // 是否创建了术语库
	aiTransHistoryLimit?: number
	aiTransTrialLimitNumPerDay?: number
	aiTransTrialLimitNumPerMon?: number
}

export enum Roles {
	base = "base",
	high = "high",
	middle = "middle",
	global_base = "global_base",
	global_middle = "global_middle",
	global_high = "global_high",
}

export interface IRoleRights {
	imageTranBaseCost?: number | null
	imageTranOCRCostWord?: number | null
	imageTranMagnification?: number | null
	imageTranCostWord?: number | null
	batchTransMaxLimit: number
	batchUploadLimit: number
	charsMaxLimit: number
	historySaveDayLimit: number
	memberCountLimit: number | null
	termMaxSize: number
	funPowerCfgId: Roles
	termMultiTbSize: number | null
	termSingleTbSize: number | null	
	transCountLimit: number 
	transEngine: number
	transFileMaxSize: number | null
	transLangLimitStr: string
	pdfPages: number
	fileTypes: string | null
	ocrCostWord?: number
	regionRedrawCostWord?: number
}

export interface ILanguage {
	code: string;
    name: string;
}
